import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import useStyles from '../style';
import Loading from '../../../../components/Loading';
import { FilterStatusHeader } from './FilterStatusHeader';
import { canShowEdit } from '../../../../utils/functions';

export function ContactAssGroup({ providerId, isEditing, fornecedorId }) {
  const classes = useStyles();

  const [contactGroups, setContactGroups] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [anchorsById, setAnchorsById] = useState({});
  const [destinosById, setDestinosById] = useState({});
  const [isLoading, setLoading] = useState(false);
  const memoizedTableAss = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(2730, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Rede',
            field: 'rede',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Destino de Pagamento',
            field: 'destinoPagamento',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(2730, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={
                      {pathname: `/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}`,
                      state: {fornecedorContatoAssinaturaId: rowData.fornecedorContatoAssinaturaId }}
                    }

                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(2730, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={
                      {
                        pathname:`/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}/editar`,
                        state: {fornecedorContatoAssinaturaId: rowData.fornecedorContatoAssinaturaId }
                      }
                    }
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={contactGroups}
      />
    ),
    [contactGroups],
  );

  const fetchContactInfo = async (localAnchorsById, localDestinosById) => {
    const anchorsMap = localAnchorsById || anchorsById;
    const destinosMap = localDestinosById || destinosById;

    setLoading(true);
    const res = await api.get(
      `FornecedoresContatosAssinaturas/ConsultarFornecedorId?fornecedorId=${fornecedorId}&${
        status ? `status=${status}` : ''
      }`,
    );
    if (
      res.data.resposta?.[0]?.key === 'Notificacao' ||
      res.data.resposta?.[0]?.key === '' ||
      res.data.resposta?.[0]?.message === 'Valor não encontrado'
    ) {
      setContactGroups([]);
    } else {
      setContactGroups(
        res.data.resposta.map((contact) => ({
          ...contact,
          telefone:
            (contact?.ddd ? `(${contact?.ddd}) ` : '') +
            `${contact?.telefone}`,
          rede:
            anchorsMap?.[contact?.ancoraId] ??
            anchorsMap?.[String(contact?.ancoraId)] ??
            '—',
          destinoPagamento:
            destinosMap?.[contact?.destinoPagamentoId] ??
            destinosMap?.[String(contact?.destinoPagamentoId)] ??
            '—',
        })),
      );
    }
    setLoading(false);
  };

  const loadAuxiliaryData = async () => {
    try {
      const [anchorsResponse, destinosResponse] = await Promise.all([
        api.get('Ancoras/Consultar?status=Ativo'),
        api.get('DestinosPagamentos/Consultar?status=Ativo'),
      ]);

      const anchorsMap = (anchorsResponse?.data?.resposta || []).reduce((acc, anchor) => {
        if (anchor?.ancoraId !== undefined && anchor?.ancoraId !== null) {
          acc[anchor.ancoraId] =
            anchor.apelido ||
            anchor.nomeFantasia ||
            anchor.razaoSocial ||
            `Ancora ${anchor.ancoraId}`;
        }
        return acc;
      }, {});

      const destinosMap = (destinosResponse?.data?.resposta || []).reduce((acc, destino) => {
        if (destino?.destinoPagamentoId !== undefined && destino?.destinoPagamentoId !== null) {
          acc[destino.destinoPagamentoId] =
            destino.destinoPagamento ||
            destino.nomeFantasia ||
            `Destino ${destino.destinoPagamentoId}`;
        }
        return acc;
      }, {});

      setAnchorsById(anchorsMap);
      setDestinosById(destinosMap);
      await fetchContactInfo(anchorsMap, destinosMap);
    } catch (error) {
      console.error('Erro ao carregar dados auxiliares de redes/destinos:', error);
      await fetchContactInfo();
    }
  };

  useEffect(() => {
    if (providerId) {
      loadAuxiliaryData();
    }
  }, [providerId]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Contatos que podem assinar contratos</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          <Grid item xs={12} className={classes.registerBtn}>
            <FilterStatusHeader
              fetchFunc={fetchContactInfo}
              status={status}
              setStatus={setStatus}
            />
            {isEditing && !!findPermission(2730, 'Cadastrar') && (
              <Link
                className={classes.button}
                to={`/app/fornecedor/${providerId}/cadastrar-grupo-contato-ass`}
              >
                Novo Item
              </Link>
            )}
          </Grid>

          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {memoizedTableAss}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
